{
  "upload": {
    "title": "Su marca",
    "subtitle": "Suba la imagen de su marca o ingrese una marca de texto",
    "selectType": "¿Cuál opción describe mejor su marca?",
    "logoTrademark": "Marca con logo",
    "logoDescription": "Logo de marca incluyendo texto",
    "figurativeTrademark": "Marca figurativa",
    "figurativeDescription": "Elementos gráficos de la marca sin texto",
    "wordTrademark": "Marca de palabra",
    "wordDescription": "Nombre de marca o eslogan",
    "uploadYour": "Suba su marca {{type}}",
    "dragDrop": "Arrastre y suelte su imagen aquí, o",
    "browseFiles": "buscar archivos",
    "supportedFormats": "Formatos soportados: PNG, JPG, GIF",
    "enterWordMark": "Ingrese su marca de palabra",
    "wordPlaceholder": "Ingrese el texto de su marca",
    "uploadWordMark": "Subir marca de palabra",
    "removeImage": "Eliminar imagen",
    "uploading": "Subiendo marca...",
    "uploadSuccess": "¡Marca subida exitosamente!",
    "imageSuccess": "Imagen de marca subida exitosamente",
    "uploadDifferent": "Subir otra marca",
    "selectImage": "Seleccione una imagen para subir automáticamente",
    "uploadError": "Error al subir la marca. Por favor intente de nuevo."
  },
  "analysis": {
    "title": "Análisis con IA",
    "subtitle": "Nuestra IA analizará su marca en busca de distintividad, conflictos potenciales y estrategia de registro",
    "readyTitle": "Listo para el análisis de marca con IA",
    "readySubtitle": "Nuestra IA analizará su marca en busca de distintividad, conflictos potenciales y estrategia de registro",
    "yourTrademark": "Su marca",
    "trademarkRequired": "Marca requerida",
    "businessProfile": "Perfil empresarial",
    "businessRequired": "Perfil empresarial requerido",
    "trademarkName": "Nombre de la marca",
    "trademarkNameDesc": "Este es el nombre o texto que estará protegido bajo su registro de marca",
    "trademarkType": "Tipo de marca",
    "logoTypeDesc": "Un diseño visual o logotipo que representa su marca",
    "wordTypeDesc": "Una palabra o frase que identifica sus bienes o servicios",
    "detailedDescription": "Descripción detallada",
    "trademarkDescription": "Descripción de la marca",
    "viewDescription": "Ver descripción detallada de la marca",
    "descriptionHelp": "Esta descripción ayuda a nuestra IA a comprender los elementos visuales y conceptuales de su marca",
    "descRequired": "Descripción requerida",
    "descRequiredMsg": "Por favor agregue una descripción detallada de su marca para continuar con el análisis",
    "descRequiredHelp": "Una buena descripción incluye colores, elementos de diseño, fuentes y apariencia general",
    "noTrademark": "Ninguna marca seleccionada",
    "noTrademarkMsg": "Por favor complete el paso de carga de marca primero",
    "noTrademarkHelp": "Necesita cargar su marca antes de que podamos analizarla",
    "readyToAnalyse": "Listo para analizar",
    "analyseButton": "Analizar mi marca",
    "analysing": "Analizando su marca...",
    "analysisComplete": "Análisis completado",
    "viewReport": "Ver informe completo",
    "overallScore": "Puntuación general",
    "distinctiveness": "Distintividad",
    "conflictRisk": "Riesgo de conflicto",
    "registrability": "Registrabilidad",
    "recommendations": "Recomendaciones",
    "potentialConflicts": "Conflictos potenciales",
    "noConflicts": "No se encontraron conflictos significativos",
    "needsUpload": "Necesita subir su marca antes de que podamos analizarla",
    "classRecommendations": "Recomendaciones de clase",
    "suggestedClasses": "Clases de Niza sugeridas"
  },
  "business": {
    "title": "Información comercial",
    "complete": "Información comercial completada",
    "completeDescription": "Su información comercial se ha guardado correctamente y se utilizará para proporcionar recomendaciones precisas de marcas.",
    "subtitle": "Cuéntenos sobre su negocio para que Marko pueda proporcionar recomendaciones personalizadas",
    "ownerType": "Tipo de propietario de marca",
    "individual": "Individual",
    "company": "Empresa",
    "partnership": "Sociedad",
    "businessName": "Nombre comercial",
    "tradingAs": "Operando como",
    "registrationNumber": "Número de registro",
    "industry": "Industria",
    "selectIndustry": "Seleccione su industria",
    "goodsServices": "Bienes y servicios",
    "describeGoodsServices": "Describa los bienes o servicios que cubrirá su marca",
    "markoAnalyse": "Marko analizará su información mientras escribe.",
    "analysed": "He analizado su marca"
  },
  "classes": {
    "title": "Clasificación de Niza",
    "subtitle": "Seleccione las clases que mejor describan sus bienes y servicios",
    "selectedClasses": "Clases seleccionadas",
    "noClassesSelected": "No hay clases seleccionadas",
    "addClass": "Agregar clase",
    "removeClass": "Eliminar clase",
    "searchClasses": "Buscar clases...",
    "classNumber": "Clase {{number}}",
    "viewDetails": "Ver detalles de la clase"
  }
}
